export default __webpack_public_path__ + "static/media/settlement.22daaae6.svg";